import {
  SET_PAGE_SIZE,
  SET_SEARCH_QUERY,
  SET_CONFIGURED_POS_VISIBLE,
  SET_CONFIGURED_BOARDS_VISIBLE,
  SET_CONFIGURED_PRINTERS_VISIBLE,
  SET_CURRENT_PAGINATION_PAGE,
  UPDATE_OFFSET,
} from './actionTypes'

export const setPageSize = (pageSize) => ({
  type: SET_PAGE_SIZE,
  payload: pageSize,
})

export const setSearchQuery = (searchedText) => ({
  type: SET_SEARCH_QUERY,
  payload: searchedText,
})

export const setConfiguredPOSVisible = (isVisible) => ({
  type: SET_CONFIGURED_POS_VISIBLE,
  payload: isVisible,
})

export const setConfiguredBoardsVisible = (isVisible) => ({
  type: SET_CONFIGURED_BOARDS_VISIBLE,
  payload: isVisible,
})

export const setConfiguredPrintersVisible = (isVisible) => ({
  type: SET_CONFIGURED_PRINTERS_VISIBLE,
  payload: isVisible,
})

export const setCurrentPaginationPage = ({ screen, page }) => ({
  type: SET_CURRENT_PAGINATION_PAGE,
  payload: {
    screen,
    page,
  },
})

export const updateOffset = (offset) => ({
  type: UPDATE_OFFSET,
  payload: offset,
})
